// extracted by mini-css-extract-plugin
export default {"container":"Loader_container__X02md","anim":"Loader_anim__8rmrk"};